<template>
	<span class="relative z-0 inline-flex NOTshadow-sm rounded-full">
		<button
			v-for="(tab, idx) in tabs"
			:key="'tab-' + idx"
			:class="[
				'xfocus:text-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange focus:border-orange',
				idx == 0
					? 'relative inline-flex items-center pl-4 pr-3 py-1.5 rounded-l-full border-2 border-gray-200 font-medium'
					: '',
				idx == tabs.length - 1
					? '-ml-px relative inline-flex items-center pl-3 pr-4 py-1.5 rounded-r-full border-2 border-gray-200'
					: '',
				idx > 0 && idx < tabs.length - 1
					? '-ml-px relative inline-flex items-center px-3 py-1.5 border-2'
					: '',
				isActive(tab)
					? 'border-orange bg-orange font-semibold text-white'
					: 'font-medium text-gray-600 hover:bg-gray-50',
			]"
			:aria-current="isActive(tab) ? 'page' : undefined"
			v-on:click="activeTab = tab.name"
			type="button"
		>
			{{ tab.name }}
		</button>
	</span>
</template>

<script>
import UiTabs from "./Tabs.vue";

export default {
	mixins: [UiTabs],
};
</script>
